import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "row g-2 ps-3" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = { class: "input-group input-group-sm shadow-sm" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "input-group input-group-sm shadow-sm" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "mt-3 ps-3" }
const _hoisted_10 = { class: "form-check form-switch" }

import { reactive, watch, computed, PropType, onMounted } from "vue";
import { useStore } from "vuex";
import type { TelegramChannel } from "@/stores/telegramChannels";
import type { Rank } from "@/store/Ranks/RanksInterfaces";
import ChannelBasicInfo from "./ChannelBasicInfo.vue";
import ChannelKickConfig from "./ChannelKickConfig.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'NetworkingChannelForm',
  props: {
  modelValue: {
    type: Object as PropType<TelegramChannel>,
    required: true,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "validation"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const store = useStore();

const formData = reactive<TelegramChannel>({ ...props.modelValue });

// Ranks
const availableRanks = computed<Rank[]>(() => {
  const ranksGetter = store.getters["ranks/allRanks"];
  const ranksMap =
    typeof ranksGetter === "function" ? ranksGetter() : ranksGetter;
  return ranksMap ? Array.from(ranksMap.values()) : [];
});

onMounted(() => {
  store.dispatch("ranks/doGetRanksInfo");
  validate();
});

// Sync
watch(
  formData,
  (newVal) => {
    emit("update:modelValue", newVal);
    validate();
  },
  { deep: true }
);

const validate = () => {
  const errors: string[] = [];
  if (!formData.id) errors.push("El ID de Telegram es requerido");
  if (!formData.name) errors.push("El nombre del canal es requerido");
  emit("validation", errors);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ChannelBasicInfo, {
      id: formData.id,
      "onUpdate:id": _cache[0] || (_cache[0] = ($event: any) => ((formData.id) = $event)),
      name: formData.name,
      "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => ((formData.name) = $event)),
      priority: formData.priority,
      "onUpdate:priority": _cache[2] || (_cache[2] = ($event: any) => ((formData.priority) = $event)),
      active: formData.active,
      "onUpdate:active": _cache[3] || (_cache[3] = ($event: any) => ((formData.active) = $event)),
      "disabled-id": __props.isEditing
    }, null, 8, ["id", "name", "priority", "active", "disabled-id"]),
    _cache[20] || (_cache[20] = _createElementVNode("hr", { class: "my-3 text-muted opacity-25" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _cache[19] || (_cache[19] = _createElementVNode("h6", { class: "fw-bold text-dark mb-2" }, [
        _createElementVNode("i", { class: "fas fa-medal fa-fw me-2 text-warning" }),
        _createTextVNode("Requisitos de Rango ")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-1" }, "Rango Mínimo", -1)),
          _createElementVNode("div", _hoisted_4, [
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "input-group-text bg-white border-end-0 text-muted" }, [
              _createElementVNode("i", { class: "fas fa-trophy" })
            ], -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select bg-white border-start-0",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.minRank) = $event)),
              style: {"border-left":"0"}
            }, [
              _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "-- Cualquiera --", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRanks.value, (rank) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: rank._id,
                  value: rank._id
                }, _toDisplayString(rank.name), 9, _hoisted_5))
              }), 128))
            ], 512), [
              [_vModelSelect, formData.minRank]
            ])
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("small", {
            class: "text-muted small mt-1 d-block",
            style: {"font-size":"0.7rem"}
          }, " El usuario debe tener al menos este rango. ", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label text-muted small fw-bold mb-1" }, "Rango Auto Admin (Opcional)", -1)),
          _createElementVNode("div", _hoisted_7, [
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "input-group-text bg-white border-end-0 text-muted" }, [
              _createElementVNode("i", { class: "fas fa-crown" })
            ], -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select bg-white border-start-0",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.minAdminRank) = $event)),
              style: {"border-left":"0"}
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("option", { value: "" }, "-- N/A --", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableRanks.value, (rank) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: rank._id,
                  value: rank._id
                }, _toDisplayString(rank.name), 9, _hoisted_8))
              }), 128))
            ], 512), [
              [_vModelSelect, formData.minAdminRank]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input cursor-pointer",
            type: "checkbox",
            id: "visibleWhenRestrictedSwitch",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.visibleWhenRestricted) = $event))
          }, null, 512), [
            [_vModelCheckbox, formData.visibleWhenRestricted]
          ]),
          _cache[17] || (_cache[17] = _createElementVNode("label", {
            class: "form-check-label cursor-pointer text-dark small fw-medium",
            for: "visibleWhenRestrictedSwitch"
          }, " Mostrar como Bloqueado si el Rango es insuficiente ", -1))
        ]),
        _cache[18] || (_cache[18] = _createElementVNode("small", {
          class: "text-muted small ps-2 d-block",
          style: {"font-size":"0.7rem"}
        }, " Si se activa, el canal aparecerá con un candado 🔒 para los usuarios que no cumplan el requisito. De lo contrario, se ocultará por completo. ", -1))
      ])
    ]),
    _cache[21] || (_cache[21] = _createElementVNode("hr", { class: "my-3 text-muted opacity-25" }, null, -1)),
    _createVNode(ChannelKickConfig, {
      kickUsers: formData.kickUsers,
      "onUpdate:kickUsers": _cache[7] || (_cache[7] = ($event: any) => ((formData.kickUsers) = $event)),
      kickAfter: formData.kickAfter,
      "onUpdate:kickAfter": _cache[8] || (_cache[8] = ($event: any) => ((formData.kickAfter) = $event)),
      kickAfterUnit: formData.kickAfterUnit,
      "onUpdate:kickAfterUnit": _cache[9] || (_cache[9] = ($event: any) => ((formData.kickAfterUnit) = $event))
    }, null, 8, ["kickUsers", "kickAfter", "kickAfterUnit"])
  ]))
}
}

})